import MoneyInput from '../common/MoneyInput';
import styles from './EditBasicFields.module.css';

/**
 * EditBasicFields Component
 *
 * Handles the basic input fields for edit mode: amount, description, and date
 */
function EditBasicFields({
    _transactionType,
    amount,
    description,
    date,
    errors,
    onAmountChange,
    onDescriptionChange,
    onDateChange,
    clearError
}) {
    const handleAmountChange = (parsedValue) => {
        clearError('amount');
        const value = parsedValue !== null ? parsedValue.toString() : '';
        onAmountChange(value);
    };

    const handleAmountBlur = () => {
        // No special handling needed - MoneyInput handles formatting
    };

    const handleDescriptionChange = (value) => {
        onDescriptionChange(value);
        clearError('description');
    };

    const handleDateChange = (value) => {
        onDateChange(value);
        clearError('date');
    };

    return (
        <div className={styles.container}>
            <MoneyInput
                value={amount ? parseFloat(amount) : null}
                onChange={handleAmountChange}
                onBlur={handleAmountBlur}
                placeholder="Total Amount"
                min={0}
                max={9999999.99}
                className={`${styles.amountInput} ${errors.amount ? styles.error : ''}`}
            />
            <input
                type="text"
                value={description}
                onChange={(e) => handleDescriptionChange(e.target.value)}
                className={`${styles.descriptionInput} ${errors.description ? styles.error : ''}`}
            />
            <input
                type="date"
                value={date}
                onChange={(e) => handleDateChange(e.target.value)}
                className={`${styles.dateInput} ${errors.date ? styles.error : ''}`}
            />
        </div>
    );
}

export default EditBasicFields;
